import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import { sizeOf } from "../../utils/propTypes";
import { RadioGroup } from "@base-ui/react/radio-group";
import { Radio as BaseRadio } from "@base-ui/react/radio";
import css from "./Radio.module.css";

const RadioItem = React.forwardRef(
  (
    { value, label, description, disabled = false, className, ...rest },
    ref,
  ) => (
    <label
      className={clsx(css.item, className)}
      data-disabled={disabled || undefined}
    >
      <BaseRadio.Root
        ref={ref}
        value={value}
        className={css.radio}
        disabled={disabled}
        {...rest}
      >
        <BaseRadio.Indicator className={css.indicator} />
      </BaseRadio.Root>
      {label && (
        <span className={css.text}>
          <span className={css.label}>{label}</span>
          {description && (
            <span className={css.description}>{description}</span>
          )}
        </span>
      )}
    </label>
  ),
);

RadioItem.displayName = "RadioItem";

RadioItem.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string,
  description: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

const RadioGroupRoot = React.forwardRef(
  (
    {
      value,
      defaultValue,
      onValueChange,
      disabled = false,
      name,
      orientation = "vertical",
      size = "md",
      className,
      children,
      ...rest
    },
    ref,
  ) => (
    <RadioGroup
      ref={ref}
      className={clsx(css.group, className)}
      value={value}
      defaultValue={defaultValue}
      onValueChange={onValueChange}
      disabled={disabled}
      name={name}
      data-orientation={orientation}
      data-size={size}
      {...rest}
    >
      {children}
    </RadioGroup>
  ),
);

RadioGroupRoot.displayName = "RadioGroup";

RadioGroupRoot.propTypes = {
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  onValueChange: PropTypes.func,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  orientation: PropTypes.oneOf(["vertical", "horizontal"]),
  size: sizeOf("sm", "md"),
  className: PropTypes.string,
  children: PropTypes.node,
};

const Radio = { Group: RadioGroupRoot, Item: RadioItem };

export default Radio;
